<template>
  <div v-loading="loading">
    <div id="trip_plan_survey"
         style="padding:10px"
         ref="trip_plan_survey">
      <!-- 头 -->
      <div style="display:flex;margin-bottom:10px">
        <!-- 图，美化 -->

        <div style="background-color:#ff5421;width:55%;border:1px solid #ff5421;height:60px;padding:10px 0">
          <p style="text-align:center;font-size:25px;color:#fff;font-weight:900">
            【行程概况】 仅用于确定游玩内容
          </p>
          <p style="text-align:center;font-size:15px;color:#fff;font-weight:900">
            （更多推荐、美食等 会根据此行程生成细旅行指南）
          </p>
        </div>
        <div style="background-color:#FFF;width:40%;height:80px;border:1px solid #ff5421">
          <el-image src="http://szsxtravel.top/plan_travel_title_image.png"
                    style="height:100%;width:auto"
                    fit="width"></el-image>
        </div>
        <div style="background-color:#ff5421;height:80px;border:1px solid #ff5421">
          <el-image fit='fill'
                    style="height:80px;width:80px;"
                    src="http://szsxtravel.top/logo.png"></el-image>
        </div>
      </div>
      <!-- 行程表 -->
      <el-table :data="table_data"
                @cell-mouse-enter="cellMouseEnter"
                @cell-mouse-leave="cellMouseLeave"
                border
                style="width: 100%">
        <el-table-column label="行程/天"
                         width="90">
          <template slot-scope="day">
            <div class="trip_table_day_style"> 第 {{table_data.indexOf(day.row)+1}}天</div>
            <!-- 日期 -->
            <!-- <div>
              {{dateOfThisDate(table_data.indexOf(day.row))}}
            </div>
            <div class="traver_plan_table_weekend_style">
              <span v-if="dayOfThisDate(table_data.indexOf(day.row))==1">【星期一】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(day.row))==2">【星期二】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(day.row))==3">【星期三】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(day.row))==4">【星期四】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(day.row))==5">【星期五】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(day.row))==6">【星期六】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(day.row))==0">【星期日】</span>
            </div> -->
          </template>
        </el-table-column>
        <!-- 日期 -->
        <el-table-column label="日期"
                         width="130">
          <template slot-scope="date">
            <div>
              {{dateOfThisDate(table_data.indexOf(date.row))}}
            </div>
            <div class="traver_plan_table_weekend_style">
              <span v-if="dayOfThisDate(table_data.indexOf(date.row))==1">【星期一】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(date.row))==2">【星期二】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(date.row))==3">【星期三】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(date.row))==4">【星期四】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(date.row))==5">【星期五】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(date.row))==6">【星期六】</span>
              <span v-if="dayOfThisDate(table_data.indexOf(date.row))==0">【星期日】</span>
            </div>
          </template>
        </el-table-column>
        <!-- -----------------目的地和行程状态----------------- -->
        <el-table-column label="目的地"
                         width="100">
          <template slot-scope="dest">
            <div>
              <!-- 显示离开目的地 -->
              <div>
                <span v-if="dest.row.departureTrip.dayTripTraverList.length !==0">
                  <span class="day_trip_item_departure">离开</span>
                  <span> {{dest.row.departureTrip.dayTripInfo.dest}}</span>
                </span>
              </div>
              <!-- 显示中转目的地 -->
              <div>
                <span v-if="dest.row.transitTrip.dayTripTraverList.length !==0">
                  <span>{{dest.row.transitTrip.dayTripInfo.dest}} </span>
                  <span class="day_trip_item_transit">中转</span>
                </span>
              </div>
              <!-- 显示抵达目的地 -->
              <div>
                <span v-if="dest.row.arrivalTrip.dayTripTraverList.length !==0">
                  <span class="day_trip_item_arrival">抵达</span>

                  <span> {{dest.row.arrivalTrip.dayTripInfo.dest}}</span>
                </span>
              </div>
              <!-- 显示整日目的地 -->
              <div>
                <span v-if="dest.row.allDayTrip.dayTripTraverList.length !==0">
                  <span>{{dest.row.allDayTrip.dayTripInfo.dest}} </span>
                  <span class="day_trip_item_allday">整日</span>
                </span>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- -----------------日行程概况----------------- -->
        <el-table-column label="日行程概况">
          <template slot-scope="survey">
            <!-- 离开 0 -->
            <div style="text-align:center;font-size:10px;"
                 v-if="survey.row.departureTrip.dayTripTraverList.length !=0">
              --- <span style="color:green">离开 </span>：{{survey.row.departureTrip.dayTripInfo.dest}}---
              <!-- 建议出发时间 -->
              <div @click="showRecommandTime(survey.row.departureTrip.dayTripInfo)"
                   class="recommend_time"> 建议出发时间：
                <span v-if="modifyTime!==survey.row.departureTrip.dayTripInfo.id">{{survey.row.departureTrip.dayTripInfo.recommend_time}}</span>
                <el-input v-else
                          @change="modifyTimeEnter"
                          @blur="modifyTimeEnter"
                          v-model="survey.row.departureTrip.dayTripInfo.recommend_time"></el-input>
              </div>
              <!-- 建议出发时间结束 -->

            </div>

            <p v-for="item of  survey.row.departureTrip.dayTripTraverList"
               :key="item.key">

              <span class="day_trip_item"
                    v-if="'traver_title' in item">
                📍 {{item.traver_title}}
                <span @click="addTraverTitleIntro(item,table_data.indexOf(survey.row),'departureTrip')"
                      class="day_trip_editor"><i class="el-icon-edit"></i>
                </span>
                <!-- ----------------显示说明---------- -->
                <div v-if="item.traver_title_intro"
                     class="traver_title_introduce"
                     v-html="item.traver_title_intro"></div>
                <!-- ----------------说明结束-------------- -->
              </span>
              <span v-else>
                🏠 {{item.residence_name}}</span>
            </p>

            <!-- 中转 0 -->
            <div style="text-align:center;font-size:10px;"
                 v-if="survey.row.transitTrip.dayTripTraverList.length !=0">
              ---{{survey.row.transitTrip.dayTripInfo.dest}} ：<span style="color:#FFC300">中转</span> ---
              <!-- 建议出发时间 -->
              <div @click="showRecommandTime(survey.row.transitTrip.dayTripInfo)"
                   class="recommend_time"> 建议出发时间：
                <span v-if="modifyTime!==survey.row.transitTrip.dayTripInfo.id">{{survey.row.transitTrip.dayTripInfo.recommend_time}}</span>
                <el-input v-else
                          @change="modifyTimeEnter"
                          v-model="survey.row.transitTrip.dayTripInfo.recommend_time"></el-input>
              </div>
              <!-- 建议出发时间结束 -->

            </div>
            <p v-for="item of  survey.row.transitTrip.dayTripTraverList"
               :key="item.key">

              <span class="day_trip_item"
                    v-if="'traver_title' in item">
                📍 {{item.traver_title}}
                <span @click="addTraverTitleIntro(item,table_data.indexOf(survey.row),'transitTrip')"
                      class="day_trip_editor"><i class="el-icon-edit"></i>
                </span>
                <!-- ----------------显示说明---------- -->
                <div class="traver_title_introduce"
                     v-html="item.traver_title_intro"></div>
                <!-- ----------------说明结束-------------- -->
              </span>
              <span v-else>
                🏠 {{item.residence_name}}</span>
            </p>

            <!-- 抵达 1 -->
            <div style="text-align:center;font-size:10px;"
                 v-if="survey.row.arrivalTrip.dayTripTraverList.length !=0">
              --- <span style="color:#163AF3">抵达：</span> {{survey.row.arrivalTrip.dayTripInfo.dest}}---
              <!-- 建议出发时间 -->
              <div @click="showRecommandTime(survey.row.arrivalTrip.dayTripInfo)"
                   class="recommend_time">建议出发时间：
                <span v-if="modifyTime!==survey.row.arrivalTrip.dayTripInfo.id">{{survey.row.arrivalTrip.dayTripInfo.recommend_time}}</span>
                <el-input v-else
                          @change="modifyTimeEnter"
                          v-model="survey.row.arrivalTrip.dayTripInfo.recommend_time"></el-input>
              </div>
              <!-- 建议出发时间结束 -->
            </div>

            <p v-for="item of  survey.row.arrivalTrip.dayTripTraverList"
               :key="item.key">
              <span class="day_trip_item"
                    v-if="'traver_title' in item">
                📍 {{item.traver_title}}
                <span @click="addTraverTitleIntro(item,table_data.indexOf(survey.row),'arrivalTrip')"
                      class="day_trip_editor"><i class="el-icon-edit"></i>
                </span>
                <!-- ----------------显示说明---------- -->
                <div v-if="item.traver_title_intro"
                     class="traver_title_introduce"
                     v-html="item.traver_title_intro"></div>
                <!-- ----------------说明结束-------------- -->
              </span>
              <span v-else>
                🏠 {{item.residence_name}}
              </span>
            </p>

            <!-- 整日 2 -->
            <div style="text-align:center;font-size:10px;"
                 v-if="survey.row.allDayTrip.dayTripTraverList.length !=0">
              --- <span style="color:#ff5421"> 整日 </span>: {{survey.row.allDayTrip.dayTripInfo.dest}} ---
              <!-- 建议出发时间 -->
              <div @click="showRecommandTime(survey.row.allDayTrip.dayTripInfo)"
                   class="recommend_time">建议出发时间：
                <span v-if="modifyTime!==survey.row.allDayTrip.dayTripInfo.id">{{survey.row.allDayTrip.dayTripInfo.recommend_time}}</span>
                <el-input v-else
                          @change="modifyTimeEnter"
                          v-model="survey.row.allDayTrip.dayTripInfo.recommend_time"></el-input>
              </div>
              <!-- 建议出发时间结束 -->
            </div>

            <p v-for="item of  survey.row.allDayTrip.dayTripTraverList"
               :key="item.key">
              <span class="day_trip_item"
                    v-if="'traver_title' in item">
                📍 {{item.traver_title}}
                <span @click="addTraverTitleIntro(item,table_data.indexOf(survey.row),'allDayTrip')"
                      class="day_trip_editor"><i class="el-icon-edit"></i>
                </span>
                <!-- ----------------显示说明---------- -->
                <div v-if="item.traver_title_intro"
                     class="traver_title_introduce"
                     v-html="item.traver_title_intro"></div>
                <!-- ----------------说明结束-------------- -->
              </span>
              <span v-else>
                🏠 {{item.residence_name}}</span>
            </p>

          </template>
        </el-table-column>
        <!-- -----------------住宿----------------- -->
        <el-table-column prop="address"
                         label="住宿">
          <template slot-scope="residence">
            <!-- 离开 -->
            <!-- <p v-for="item of  residence.row.departureTrip.dayTripTraverList"
               :key="item.key">
              <span v-if="'residence_name' in item">
                <span v-if="item.residence_type=='1'">
                  {{residence.row.departureTrip.dayTripInfo.dest}}-酒店:</span>
                <span v-if="item.residence_type=='2'">
                  {{residence.row.departureTrip.dayTripInfo.dest}}-民宿:</span>
                <span v-if="item.residence_type=='3'">
                  {{residence.row.departureTrip.dayTripInfo.dest}}-别墅:</span>
                {{item.residence_name}}</span>
            </p> -->
            <!-- 中转 -->
            <p v-for="item of  residence.row.arrivalTrip.dayTripTraverList"
               :key="item.key">
              <span v-if="'residence_name' in item">
                <span v-if="item.residence_type=='1'">
                  {{residence.row.arrivalTrip.dayTripInfo.dest}}-酒店:</span>
                <span v-if="item.residence_type=='2'">
                  {{residence.row.arrivalTrip.dayTripInfo.dest}}-民宿:</span>
                <span v-if="item.residence_type=='3'">
                  {{residence.row.arrivalTrip.dayTripInfo.dest}}-别墅:</span>
                {{item.residence_name}}</span>
            </p>
            <!-- 抵达 -->
            <p v-for="item of  residence.row.transitTrip.dayTripTraverList"
               :key="item.key">
              <span v-if="'residence_name' in item">
                <span v-if="item.residence_type=='1'">
                  {{residence.row.transitTrip.dayTripInfo.dest}}-酒店:</span>
                <span v-if="item.residence_type=='2'">
                  {{residence.row.transitTrip.dayTripInfo.dest}}-民宿:</span>
                <span v-if="item.residence_type=='3'">
                  {{residence.row.transitTrip.dayTripInfo.dest}}-别墅:</span>
                {{item.residence_name}}</span>
            </p>
            <!-- 整日 -->
            <p v-for="item of  residence.row.allDayTrip.dayTripTraverList"
               :key="item.key">
              <span v-if="'residence_name' in item">
                <span v-if="item.residence_type=='1'">
                  {{residence.row.allDayTrip.dayTripInfo.dest}}-酒店:</span>
                <span v-if="item.residence_type=='2'">
                  {{residence.row.allDayTrip.dayTripInfo.dest}}-民宿:</span>
                <span v-if="item.residence_type=='3'">
                  {{residence.row.allDayTrip.dayTripInfo.dest}}-别墅:</span>
                {{item.residence_name}}</span>
            </p>
          </template>
        </el-table-column>

        <!-- 抵达说明 -->
        <!-- 
        <el-table-column label="说明">
          <template slot-scope="remark"
                    style="height:100%">
            编辑离开 说明 
            <div v-if="remark.row.departureTrip.dayTripTraverList.length !==0">

              <p style="font-weight:900"> 离开说明：</p>

              <el-input type="textarea"
                        v-if="remark.row == showDepartureTripRemark"
                        placeholder='编辑离开说明'
                        v-model="remark.row.departureTrip.remark"
                        rows="3"
                        @keyup.enter.native="departureTripEnter"
                        size="mini"></el-input>
              <p v-else>{{remark.row.departureTrip.remark}}</p>
            </div>
          编辑中转 说明
            <div v-if="remark.row.transitTrip.dayTripTraverList.length !==0">
              <p style="font-weight:900">中转说明：</p>
              <el-input type="textarea"
                        v-if="remark.row == showTransitTripRemark"
                        v-model="remark.row.transitTrip.remark"
                        placeholder='编辑中转说明'
                        rows="3"
                        @keyup.enter.native="transitTripEnter"
                        size="mini"></el-input>
              <p v-else>{{remark.row.transitTrip.remark}}</p>
            </div>
             编辑抵达 说明 
            <div v-if="remark.row.arrivalTrip.dayTripTraverList.length !==0">
              <p style="font-weight:900">抵达说明：</p>

              <el-input type="textarea"
                        v-if="remark.row == showArrivalTripRemark"
                        v-model="remark.row.arrivalTrip.remark"
                        placeholder='编辑抵达说明'
                        rows="3"
                        @keyup.enter.native="arrivalTripEnter"
                        size="mini"></el-input>
              <p v-else> {{remark.row.arrivalTrip.remark}}</p>
            </div>
            编辑整日 说明 
            <div v-if="remark.row.allDayTrip.dayTripTraverList.length !==0">
              <p style="font-weight:900">整日说明：</p>

              <el-input type="textarea"
                        v-if="remark.row == showAllDayTripRemark"
                        v-model="remark.row.allDayTrip.remark"
                        placeholder='编辑整日说明'
                        rows="3"
                        @keyup.enter.native="allDayTripEnter"
                        size="mini"></el-input>
              <p v-else> {{remark.row.allDayTrip.remark}}</p>
            </div>
          </template>
        </el-table-column>
        -->
      </el-table>
      <!-- 尾 -->
      <div v-if="showFooter"
           class="share-qrcode-footer">二维码</div>
    </div>
    <!-- 功能 -->
    <div style="margin-top:10px;text-align:center">
      <el-button size="mini"
                 type="primary"
                 @click="showPlanTableImage">生成行程图片</el-button>
      <el-button size="mini"
                 type="primary"
                 @click="bandTravelPlanToRequire">绑定方案</el-button>

      <el-switch v-model="showFooter"
                 style="margin-left:50px"
                 active-color="#13ce66"
                 inactive-color="#ff4949"
                 active-text="Footer开"
                 inactive-text="Footer关">
      </el-switch>

    </div>
    <!-- 编辑器 -->
    <el-dialog title="添加说明"
               :visible.sync="dialogTraverTitleVisible">
      <!-- 编辑目的地名称 -->
      <div style="margin-bottom:10px">
        <el-input size="mini"
                  v-model="new_traver_title"></el-input>
      </div>
      <!-- 编辑说明 -->
      <editor-mini :upLoadImgAddress="`${$ip}/add_image?key_name=trip_plan_introduce`"
                   :editor_content="title_introduce"
                   @content_change="content_change"></editor-mini>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   size="mini"
                   @click="confrimSubmitTraverTitleIntro">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import editorMini from '../common/editor/editorV2mini'
export default {
  name: 'travel-plan-table',
  components: {
    editorMini,
  },
  data() {
    return {
      modifyTime: null,
      loading: false,
      table_data: this.tableDate,
      dayTripData: [],
      remark: [],
      //
      showDepartureTripRemark: {},
      showArrivalTripRemark: {},
      showAllDayTripRemark: {},
      showTransitTripRemark: {},
      //
      dialogTraverTitleVisible: false,
      new_traver_title: '',
      title_introduce: '',
      day_index: null,
      editor_item: null,
      editor_type: null,
      // 是否显示footer
      showFooter: false,
    }
  },
  props: {
    starDate: Date,
    tableDate: Array,
  },
  watch: {
    tableDate(newVal) {
      this.table_data = newVal
    },
  },
  methods: {
    modifyTimeEnter() {
      console.log('回车')
      this.modifyTime = null
    },
    showRecommandTime(item) {
      console.log(item)
      this.modifyTime = item.id
    },
    // 提交说明
    confrimSubmitTraverTitleIntro() {
      this.dialogTraverTitleVisible = false
      //
      if (this.editor_type == 'allDayTrip') {
        let change_item = this.table_data[this.day_index].allDayTrip
        change_item.dayTripTraverList.forEach((item) => {
          if (item.key == this.editor_item.key) {
            this.$forceUpdate()
            this.$set(item, 'traver_title_intro', this.title_introduce)
            // 修改迹点名称
            item.traver_title = this.new_traver_title
            console.log('当前的item', item)
          }
        })
      } else if (this.editor_type == 'departureTrip') {
        let change_item = this.table_data[this.day_index].departureTrip
        change_item.dayTripTraverList.forEach((item) => {
          if (item.key == this.editor_item.key) {
            this.$forceUpdate()
            this.$set(item, 'traver_title_intro', this.title_introduce)
            // 修改迹点名称
            item.traver_title = this.new_traver_title
            console.log('当前的item', item)
          }
        })
      } else if (this.editor_type == 'transitTrip') {
        let change_item = this.table_data[this.day_index].transitTrip
        change_item.dayTripTraverList.forEach((item) => {
          if (item.key == this.editor_item.key) {
            this.$forceUpdate()
            this.$set(item, 'traver_title_intro', this.title_introduce)
            // 修改迹点名称
            item.traver_title = this.new_traver_title
            console.log('当前的item', item)
          }
        })
      } else if (this.editor_type == 'arrivalTrip') {
        let change_item = this.table_data[this.day_index].arrivalTrip
        change_item.dayTripTraverList.forEach((item) => {
          if (item.key == this.editor_item.key) {
            this.$forceUpdate()
            this.$set(item, 'traver_title_intro', this.title_introduce)
            // 修改迹点名称
            item.traver_title = this.new_traver_title
            console.log('当前的item', item)
          }
        })
      }
      //
      this.title_introduce = ''
    },
    // 打开对话框
    addTraverTitleIntro(item, index, type) {
      // console.log(this.table_data)
      // console.log(item, index, type)
      console.log(item)
      // 打卡会话框
      this.dialogTraverTitleVisible = true
      this.new_traver_title = item.traver_title
      this.title_introduce = item.traver_title_intro
      this.day_index = index
      this.editor_type = type
      this.editor_item = item
    },
    content_change(val) {
      this.title_introduce = val
    },
    // 鼠标进入单元格是触发
    cellMouseEnter(row, column, cell, event) {
      // console.log('进入单元格', row, column, cell, event)
      if (row.transitTrip.dayTripTraverList.length != 0) {
        this.showTransitTripRemark = row
      }
      if (row.departureTrip.dayTripTraverList.length != 0) {
        this.showDepartureTripRemark = row
      }
      if (row.arrivalTrip.dayTripTraverList.length != 0) {
        this.showArrivalTripRemark = row
      }
      if (row.allDayTrip.dayTripTraverList.length != 0) {
        this.showAllDayTripRemark = row
      }
    },
    cellMouseLeave() {
      this.showDepartureTripRemark = {}
      this.showArrivalTripRemark = {}
      this.showAllDayTripRemark = {}
      this.showTransitTripRemark = {}
    },
    departureTripEnter() {
      this.showDepartureTripRemark = {}
    },
    transitTripEnter() {
      this.showTransitTripRemark = {}
    },
    arrivalTripEnter() {
      this.showArrivalTripRemark = {}
    },
    allDayTripEnter() {
      this.showAllDayTripRemark = {}
    },
    addDayTripInfo(item) {
      console.log('添加日行程说明', item)
    },
    // 当天日期
    dateOfThisDate(index) {
      // 获取所选的月份
      let year = this.starDate.getFullYear()
      let month = this.starDate.getMonth() + 1
      let date = this.starDate.getDate() + index
      // 判断 1\3\5\7\8\10\12
      // 如果当前月为12月
      if ([1, 3, 5, 7, 8, 10].indexOf(month) != -1) {
        if (date > 31) {
          let next_month = month + 1
          let new_day = date - 31
          return year + '年' + next_month + '月' + new_day + '日'
        } else {
          return year + '年' + month + '月' + date + '日'
        }
      } else if (month == 12) {
        if (date > 31) {
          let next_month = 1
          let next_year = year + 1
          let new_day = date - 31
          return next_year + '年' + next_month + '月' + new_day + '日'
        } else {
          return year + '年' + month + '月' + date + '日'
        }
      } else if (month == 2) {
        // 为2月份
        // console.log('2月')
        // 判断 闰年  平年
        if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
          // alert('您输入的年份是闰年')
          if (date > 29) {
            let next_month = month + 1
            let new_day = date - 29
            return year + '年' + next_month + '月' + new_day + '日'
          } else {
            return year + '年' + month + '月' + date + '日'
          }
        } else {
          // alert('您输入的年份是平年')
          if (date > 28) {
            let next_month = month + 1
            let new_day = date - 28
            return year + '年' + next_month + '月' + new_day + '日'
          } else {
            return year + '年' + month + '月' + date + '日'
          }
        }
      } else {
        // console.log('小月')
        if (date > 30) {
          let next_month = month + 1
          let new_day = date - 30
          return year + '年' + next_month + '月' + new_day + '日'
        } else {
          return year + '年' + month + '月' + date + '日'
        }
      }
    },
    // 获取当天星期
    dayOfThisDate(index) {
      // 获取所选的月份
      let year = this.starDate.getFullYear()
      let month = this.starDate.getMonth()
      let date = this.starDate.getDate() + index
      // 判断 1\3\5\7\8\10\12
      // 如果当前月为12月
      if ([1, 3, 5, 7, 8, 10].indexOf(month) != -1) {
        if (date > 31) {
          let next_month = month + 1
          let new_day = date - 31
          let new_date = new Date(year, next_month, new_day)
          return new_date.getDay()
        } else {
          let new_date = new Date(year, month, date)
          return new_date.getDay()
        }
      } else if (month == 2) {
        // 为2月份
        // console.log('2月')
        // 判断 闰年  平年
        if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
          // alert('您输入的年份是闰年')
          if (date > 29) {
            let next_month = month + 1
            let new_day = date - 29
            let new_date = new Date(year, next_month, new_day)
            return new_date.getDay()
          } else {
            let new_date = new Date(year, month, date)
            return new_date.getDay()
          }
        } else {
          // alert('您输入的年份是平年')
          if (date > 28) {
            let next_month = month + 1
            let new_day = date - 28
            let new_date = new Date(year, next_month, new_day)
            return new_date.getDay()
          } else {
            let new_date = new Date(year, month, date)
            return new_date.getDay()
          }
        }
      } else {
        if (date > 30) {
          let next_month = month + 1
          let new_day = date - 30
          let new_date = new Date(year, next_month, new_day)
          return new_date.getDay()
        } else {
          let new_date = new Date(year, month, date)
          return new_date.getDay()
        }
      }
    },
    // 截图
    showPlanTableImage() {
      this.loading = true
      let options = {
        allowTaint: false,
        backgroudColor: null,
        useCORS: true,
        height: document.getElementById('trip_plan_survey').offsetHeight, // 下面解决当页面滚动之后生成图片出现白边问题
        width: document.getElementById('trip_plan_survey').offsetWidth,
        windowWidth: document.body.scrollWidth,
        windowHeight: document.body.scrollHeight,
        scrollX: 0,
        scrollY: -window.pageYOffset,
        // x: 0,
        // y: 0,
        scale: 4, //
      }
      //
      // document.getElementById("certificate_div")
      html2canvas(this.$refs.trip_plan_survey, options).then((canvas) => {
        let image = canvas.toDataURL('image/png')
        // 下载图片
        this.fileDownload(image)

        // 去掉base64头，【需要压缩一下图片再上传，先图片4M太大了】
        // let data_image = image.split(";base64,")[1];
        // 上传到七牛
        // this.upLoadQiNiu(data_image);
        // this.dataURL = dataURL;
        // 创建一个a标签
        // let link = document.createElement("a");
        // link.href = canvas.toDataURL(); //下载链接
        // let operator = this.booking_info.operator;
        // link.setAttribute("download", "lession" + operator + ".png");
        // link.style.display = "none"; //a标签隐藏
        // document.body.appendChild(link);
        // link.click();
      })
    },
    // 下载图片
    fileDownload(downloadUrl) {
      let aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = downloadUrl
      aLink.download = '方案概况.png'
      // 触发点击-然后移除
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
      this.loading = false
    },
    bandTravelPlanToRequire() {
      this.$emit('bandTravelPlanToRequire')
    },
  },
}
</script>

<style >
.day_trip_editor {
  display: none;
}
.recommend_time {
  font-size: 10px;
  background-color: #fdb098;
  color: #fff;
  padding: 2px 5px;
  margin-bottom: 10px;
}
.day_trip_item:hover .day_trip_editor {
  display: inline-block;
  cursor: pointer;
}

.traver_title_introduce {
  background-color: rgb(238, 238, 238);
  padding: 2.5px 10px;
  border-radius: 10px;
  margin-bottom: 5px;
}

.trip_table_day_style {
  font-size: 20px;
  color: #ff5421;
  font-weight: bolder;
  font-style: italic;
  /* text-align: right; */
  margin-bottom: 10px;
  text-shadow: #ff5421 1px 0 0;
}
.share-qrcode-footer {
  border: 1px solid #ff5421;
  margin-top: 10px;
  padding: 10px;
}
.traver_plan_table_weekend_style {
  text-align: right;
  width: 90%;
  border-radius: 10px;
  font-size: 10px;
  /* background-color: lightsalmon; */
  /* color: #fff; */
  font-weight: 900;
}
</style>